/* Change this file to get your personal Portfolio */

// To change portfolio colors globally go to the  _globalColor.scss file

import emoji from "react-easy-emoji";
import splashAnimation from "./assets/lottie/animation_3.json"; // Rename to your file name for custom animation

// Splash Screen

const splashScreen = {
  enabled: true, // set false to disable splash screen
  animation: splashAnimation,
  duration: 2000 // Set animation duration as per your animation
};

// Summary And Greeting Section

const illustration = {
  animated: true // Set to false to use static SVG
};

const greeting = {
  username: "JHarmony",
  title: "Hello everyone, I'm George aka JHarmony.",
  subTitle: emoji(
    "As a seasoned Full Stack Software Developer with two decades of experience and a Bachelor's degree in Computer Science, I've embarked on an exhilarating journey into the realm of Web3, Blockchain technology, and Digital Collectibles."
  ),
  resumeLink:
    "https://drive.google.com/file/d/12GGdaEveF7aB_YtaaDfVuzPN5wSX0yVZ/view?usp=sharing", // Set to empty to hide the button
  displayGreeting: true // Set false to hide this section, defaults to true
};

// Social Media Links

const socialMediaLinks = {
  github: "https://github.com/jharmony",
  linkedin: "https://www.linkedin.com/in/george-de-leon-4b5202215/",
  gmail: "GDeleon1000@outlook.com",
  // gitlab: "https://gitlab.com/jharmony",
  medium: "https://medium.com/@jharmony",
  twitter: "https://twitter.com/TRue_JDHarmony",
  instagram: "https://www.instagram.com/eltio.eth/",
  // Instagram, Twitter and Kaggle are also supported in the links!
  // To customize icons and social links, tweak src/components/SocialMedia
  display: true // Set true to display this section, defaults to false
};

// Skills Section

const skillsSection = {
  title: "About Me",
  subTitle: "ENTHUSIASTIC FULL-STACK DEVELOPER WHO IS VERSED IN MULTIPLE PROGRAMMING LANGUAGES",
  skills: [
    emoji(
      "Crafting Ethereum Smart Contracts ⛓️ Building Intuitive User Interfaces for Dapps: Web and Mobile📱"
    ),
    emoji("Proficient in developing decentralized 🌐 web applications for a range of blockchain ecosystems, including Ethereum, Polygon, Arweave, Solana, and AVAX."),
    emoji(
      "Extensive collaboration 🤝 with third-party services, including Hardhat, AWS, Docker, Foundation, and Remix"
    )
  ],

  /* Make Sure to include correct Font Awesome Classname to view your icon
https://fontawesome.com/icons?d=gallery */

  softwareSkills: [
    {
      skillName: "html-5",
      fontAwesomeClassname: "fab fa-html5"
    },
    {
      skillName: "css3",
      fontAwesomeClassname: "fab fa-css3-alt"
    },
    {
      skillName: "sass",
      fontAwesomeClassname: "fab fa-sass"
    },
    {
      skillName: "JavaScript",
      fontAwesomeClassname: "fab fa-js"
    },
    {
      skillName: "reactjs",
      fontAwesomeClassname: "fab fa-react"
    },
    {
      skillName: "nodejs",
      fontAwesomeClassname: "fab fa-node"
    },
    {
      skillName: "swift",
      fontAwesomeClassname: "fab fa-swift"
    },
    {
      skillName: "npm",
      fontAwesomeClassname: "fab fa-npm"
    },
    {
      skillName: "sql-database",
      fontAwesomeClassname: "fas fa-database"
    },
    {
      skillName: "aws",
      fontAwesomeClassname: "fab fa-aws"
    },
    {
      skillName: "firebase",
      fontAwesomeClassname: "fas fa-fire"
    },
    {
      skillName: "python",
      fontAwesomeClassname: "fab fa-python"
    },
    {
      skillName: "docker",
      fontAwesomeClassname: "fab fa-docker"
    },
    {
      skillName: "bitcoin",
      fontAwesomeClassname: "fab fa-bitcoin"
    },
    {
      skillName: "Ethereum",
      fontAwesomeClassname: "fab fa-ethereum"
    }
  ],
  display: true // Set false to hide this section, defaults to true
};

// Education Section

const educationInfo = {
  display: true, // Set false to hide this section, defaults to true
  schools: [
    {
      schoolName: "Lehman H. Herburt University",
      logo: require("./assets/images/lehmanLogo.png"),
      subHeader: "Bacholor's of Science in Computer Science",
      duration: "June 2005 - April 2008",
      desc: "Seasoned professional with over two decades of experience in the field of Computer Science.",
      descBullets: [
        "Experienced community manager adept at cultivating and nurturing Web3 communities and fostering the growth of digital collectibles ecosystems.",
        "Specialized in emerging technologies, encompassing AI, Smart Contracts, and Mining Rigs within the realm of Computer Information Systems.",
        "Proficient in CI tools like AWS and well-versed in the benefits of Cloud Hypervisors over VMware as part of my Computer Information Systems studies."
      ]
    },
    {
      schoolName: "Borough of Manhattan Community College",
      logo: require("./assets/images/bmccLogo.png"),
      subHeader: "Associates of Science in Computer Operations",
      duration: "September 2003 - April 2005",
      desc: "Exprience with HMO DevOps, HTML, Javacript, CSS for building interactive and responsive UX designs",
      descBullets: [
        "Front-End development across various platform and multiple coding languages",
        "Proficient in user interface (UI) design and responsive web development, ensuring seamless user experiences on desktop and mobile devices.",
        "Applied knowledge of database management and data-driven web applications, enhancing the functionality and interactivity of web projects."
      ]
    }
  ]
};

// Your top 3 proficient stacks/tech experience

const techStack = {
  viewSkillBars: true, //Set it to true to show Proficiency Section
  experience: [
    {
      Stack: "Frontend/Design", //Insert stack or technology you have experience in
      progressPercentage: "90%" //Insert relative proficiency in percentage
    },
    {
      Stack: "Backend",
      progressPercentage: "80%"
    },
    {
      Stack: "Programming",
      progressPercentage: "85%"
    },
    {
      Stack: "Solidity",
      progressPercentage: "80%"
    }
  ],
  displayCodersrank: true // Set true to display codersrank badges section need to changes your username in src/containers/skillProgress/skillProgress.js:17:62, defaults to false
};

// Work experience section

const workExperiences = {
  display: true, //Set it to true to show workExperiences Section
  experience: [
    {
      role: "Operations Specialist",
      company: "Harlem Village Academies",
      companylogo: require("./assets/images/hvaLogo1.png"),
      date: "August 2012 – August 2022",
      desc: "Experience in the DevOps department, specializing in day-to-day operations management and collaborating directly with the non-profit's CEO. Played a key role in coordinating and executing tasks across multiple departments, ensuring seamless workflow and efficient operations. Actively contributed to strategic planning initiatives, driving innovation and enhancing operational efficiency.",
      descBullets: [
        "Engaged in strategic decision-making alongside high-level CEOs in the Charter network industry for a decade, contributing to the formulation and execution of visionary business initiatives that drove growth and innovation."
      ]
    },
    {
      role: "Lead Developer",
      company: "AIOW",
      companylogo: require("./assets/images/aiowLogo.png"),
      date: "March 2022 – October 2022",
      desc: "As a Lead Blockchain Developer at AIOW, I spearheaded the development of diverse blockchain applications, specializing in tokenization platforms and decentralized exchanges, with a paramount focus on security and reliability. Proficient in JavaScript, Node.js, and adept at harnessing frameworks like Hardhat and Foundry for smart contract development.",
      descBullets: [
        "Demonstrated expertise in the development and deployment of smart contracts across diverse platforms, showcasing a proven track record of delivering secure and efficient blockchain solutions.",
      ]
    },
    {
      role: "Backend Developer",
      company: "KnuckleHeadz Studios",
      companylogo: require("./assets/images/khzLogo.jpg"),
      date: "March 2022 – October 2022",
      desc: "As part of my role, I developed a Solidity smart contract and dApp while efficiently and implementing IPFS storage solutions. Demonstrated proficiency in Solidity and extensive expertise in Ethereum Virtual Machines (EVMs). Additionally, I played a pivotal role in community engagement by overseeing the Discord server and Twitter spaces, fostering a dynamic and engaged community.",
      descBullets: [
        "Proficient in an array of programming languages, including Solidity, JavaScript, Reactjs, Python, and Java, enabling effective communication and collaboration with cross-functional teams.",
      ]
    },
    {
      role: "Community Manager / Discord Architect",
      company: "Utopian Renaissance",
      companylogo: require("./assets/images/urLogo.png"),
      date: "March 2022 – October 2022",
      desc: "As a Community Manager, I successfully managed daily community affairs on the Utopian Renaissance Discord server and Twitter, fostering a positive and inclusive environment. I actively engaged with community members through Twitter Spaces and Discord while also recruiting and creating marketing content to drive growth. My role involved researching emerging blockchain technologies and contributing to strategic planning initiatives.",
      descBullets: [
        "Recognized for strong communication and problem-solving skills, fostering collaboration between teams to achieve organizational goals."
      ]
    }
  ]
};

/* Your Open Source Section to View Your Github Pinned Projects
To know how to get github key look at readme.md */

const openSource = {
  showGithubProfile: "true", // Set true or false to show Contact profile using Github, defaults to true
  display: true // Set false to hide this section, defaults to true
};

// Some big projects you have worked on

const bigProjects = {
  title: "Ethereum Projects",
  subtitle: "I AIDED STARTUPS WITH SMART CONTRACTS, DECENTRALIZED STORAGE, AND DAPPS",
  projects: [
    {
      image: require("./assets/images/khz1Logo.png"),
      projectName: "KnuckleHeadz Digital Collectable",
      projectDesc: "I managed community minting while developing a Solidity smart contract and dApp, utilizing IPFS for permanent storage.",
      footerLink: [
        {
          name: "Visit Official X",
          url: "https://twitter.com/KHZSTUDIO"
        }
        //  you can add extra buttons here.
      ]
    },
    {
      image: require("./assets/images/mmLogo.png"),
      projectName: "Misfit Mantis",
      projectDesc: "I oversaw community minting and contributed to the development of the Misfit Mantis collection, utilizing IPFS for permanent storage.",
      footerLink: [
        {
          name: "Visit Official X",
          url: "https://twitter.com/MisfitMantisNFT"
        }
      ]
    },
    {
      image: require("./assets/images/275Logo.png"),
      projectName: "Hood Rats",
      projectDesc: "Created and managed community minting and played a pivotal role in developing the Hood Rats collection, implementing new standards like ERC-6551, and utilizing Arweave for permanent storage.",
      footerLink: [
        {
          name: "Visit Official X",
          url: "https://twitter.com/HoodRatNFTs"
        }
      ]
    },
    {
      image: require("./assets/images/mintcheleonsLogo.png"),
      projectName: "Mintcheleons",
      projectDesc: "I deployed the smart contract, managed the whitelist of over 80,000 Ethereum addresses, and facilitated the upload to IPFS for the Mintcheleons collection.",
      footerLink: [
        {
          name: "Visit Official X",
          url: "https://twitter.com/HoodRatNFTs"
        }
      ]
    }
  ],
  display: true // Set false to hide this section, defaults to true
};

// Achievement Section
// Include certificates, talks etc

const achievementSection = {
  title: emoji("Hackathons And Collaborations 🏆 "),
  subtitle:
    "Achievements, Hackathons, Award Letters and Some Cool Stuff that I have done !",

  achievementsCards: [
    {
      title: "Arweave Community Hackathon",
      subtitle:
        "Created a front-end platform which is able to leverage the Arweave blockchian Permaweb and ANS-105 tags",
      image: require("./assets/images/arweaveLogo.png"),
      imageAlt: "TOTA Creator License Dapp",
      footerLink: [
        {
          name: "Hackathon",
          url: "https://twitter.com/onlyarweave/status/1690007805724332035"
        },
        {
          name: "TOTA Dapp NEXTJS",
          url: "https://github.com/Jharmony/tota-ar-hackathon-v"
        },
        {
          name: "TOTA Dapp Svelte",
          url: "https://github.com/Jharmony/ar-tota-hack"
        }
      ]
    },
    {
      title: "Mintcheleons Digital Collectable",
      subtitle:
        "Deployed the Solidity Smart-Contract and created the Front-End Minting Dapp while managing the minting process for allowlisted addresses.",
      image: require("./assets/images/aiowLogo.png"),
      imageAlt: "Mintcheleons",
      footerLink: [
        {
          name: "Mintcheleons on OpenSea",
          url: "https://opensea.io/collection/mintcheleons-aiow"
        },
        {
          name: "the AIOW project",
          url: "https://aiow.io"
        }
      ]
    },

    {
      title: "KnuckleHeads Digital Collectable",
      subtitle: "Completed Certifcation from SMIT for PWA Web App Development",
      image: require("./assets/images/khzLogo.jpg"),
      imageAlt: "KnuckleHeadz",
      footerLink: [
        {name: "Minting Dapp for KnuckleHeadz", url: "https://knuckleheadz.xyz"},
        {
          name: "KnuckleHeadz on OpenSea",
          url: "https://opensea.io/collection/khzstudios"
        }
      ]
    }
  ],
  display: true // Set false to hide this section, defaults to true
};

// Blogs Section

const blogSection = {
  title: "Blogs",
  subtitle:
    "Driven by a passion, I find joy in sharing my knowledge through educational posts to enlighten our community.",
  displayMediumBlogs: "false", // Set true to display fetched medium blogs instead of hardcoded ones
  blogs: [
    {
      url: "https://twitter.com/TRue_JDHarmony/status/1699034923401638259",
      title: "Technology that make digital collectables possible like AE 2.0",
      description:
        "I firmly believe that current blockchain technology, new ones that have recently emerged, and the community strongly incentivize us towards a future where the pros outweigh the cons. Here are some doxxed founders who continue building without expecting monetary returns. First, I would like to mention someone who has unselfishly provided an extensive archive of educational content, primarily through his @YouTube channel, token-gated master classes, documentation, and many others @Hashlipsnft. You can look through his X feed or his communities @sketchy_labs to learn more, but one of his most impactful contributions, by far, has been his generative Art Engine. Most digital collectible collections, including ours @HoodRatNFTs, have strongly depended on the Art Engine to create groups with large quantities of NFTs."
    },
    {
      url: "https://twitter.com/HoodRatNFTs/status/1696926513252253995",
      title: "New innovative standard on the Ethereum chain like ERC-6551",
      description:
        "It's important to mention the vital contribution of @BennyGiang and the rest of the team at @futureprimitive. Benny has worked on Ethereum standards like #ERC721 and, more recently, on the up-and-coming #ERC6551. He was also a part of one of the earliest NFT collections, @CryptoKitties. His most working work, Token Bound Accounts, thanks to ERC6551, has created a path for all collections to evolve. This new standard includes collections that have already been deployed (through smart contracts) and future ones. "
    },
    {
      url: "https://twitter.com/TRue_JDHarmony/status/1698071200973348890",
      title: "Learn about the importance of the Permaweb, decentralized storage, and Arweave",
      description:
        "Third, another worthy mention, which we have used to secure all of the data behind our NFT collection for centuries to come, is @onlyarweave and the #PermaWeb. Their technology allows data to be stored permanently on the #Arweave blockchain while only playing once upfront. @ardriveapp, an excellent UX web platform, simplifies uploading your data onto Arweave. "
    }
  ],
  display: true // Set false to hide this section, defaults to true
};

// Talks Sections

const talkSection = {
  title: "X Spaces Host",
  subtitle: emoji(
    "PASSIONATE X SPACES HOST OF THE LA BARBERIA PLATFORM."
  ),

  talks: [
    {
      title: "X SPACES HOST",
      subtitle: "LA BARBERIA WEB3 COMMUNITY",
      slides_url: "https://twitter.com/i/spaces/1RDxlamPVvkKL?s=20",
      event_url: "https://twitter.com/i/spaces/1OyJAVDWVVrxb?s=20" 
    }
  ],
  display: false // Set false to hide this section, defaults to true
};

// Podcast Section

const podcastSection = {
  title: emoji("Spaces 🎙️"),
  subtitle: "THE COMMUNITY AND I ENJOY EDUCATIONAL CONVERSTATION ON NEW TECHNOLOGIES",

  // Please Provide with Your Podcast embeded Link
  podcast: [
    "https://twitter.com/i/spaces/1MnxnpOykewGO?s=20"
  ],
  display: false // Set false to hide this section, defaults to true
};

const contactInfo = {
  title: emoji("Contact Me ☎️"),
  subtitle:
    "Discuss a project or just want to say hi? My Inbox is open for all.",
  number: " +15168475904",
  email_address: "GDeleon1000@outlook.com"
};

// Twitter Section

const twitterDetails = {
  userName: "True_JDHarmony", //Replace "twitter" with your twitter username without @
  display: true // Set true to display this section, defaults to false
};

const isHireable = true; // Set false if you are not looking for a job. Also isHireable will be display as Open for opportunities: Yes/No in the GitHub footer

export {
  illustration,
  greeting,
  socialMediaLinks,
  splashScreen,
  skillsSection,
  educationInfo,
  techStack,
  workExperiences,
  openSource,
  bigProjects,
  achievementSection,
  blogSection,
  talkSection,
  podcastSection,
  contactInfo,
  twitterDetails,
  isHireable
};
